const user = {
  namespaced: true,
  state: {
    userId: null,
    username: "",
    cardId: null,
    token: null,
  },
  mutations: {
    SET_USER_ID(state, userId) {
      state.userId = userId;
    },
    SET_USERNAME(state, username) {
      state.username = username;
    },
    SET_CARD_ID(state, cardId) {
      state.cardId = cardId
    },
    SET_TOKEN(state, token) {
      state.token = token;
      localStorage.setItem('auth_token', token)
    },
  },
};

export default user;
